const ActivityUrlDecoder = require("./ActivityUrlDecoder").default;
const Activity = require("./Activity").default;
const Log = require("@/utils/Log").default;
const UrlToActivityMapping = require("./UrlToActivityMapping").default;

export class _ActivityManager{
    constructor(){
        /** @type {ActivityWorkspace} */
        this.workspace=null;

        /** @type {Object.<string, UrlToActivityMapping>} */
        this.urlToClass={};
        this.nameToClass = {};
        /** @type {{activityClass:*, props:Object }[]} */
        this.autostart = [];
    }

    /**
     * @param {*} activityClass 
     */
    registerName(activityClass){
        let key = activityClass.name;
        Log.debug("Registering  Activity mapping by name: " + key);
        if(Object.prototype.hasOwnProperty.call(this.nameToClass, key)){
            if(this.nameToClass[key] != activityClass)
                Log.warn("Activity mapping already exists; overwriting: " + key);
        }
        this.nameToClass[key] = activityClass;
        return activityClass;
    }

    /**
     * @param {*} activityClass 
     * @param {string[]} exposedProps 
     */
    registerUrlMapping(activityClass, exposedProps){
        this.registerName(activityClass);
        let key = this.camelToDash(activityClass.name);
        Log.debug("Registering URL to Activity mapping: " + key + " ==> " + activityClass.name);
        if(Object.prototype.hasOwnProperty.call(this.urlToClass, key)){
            Log.debug("Activity mapping already exists; overwriting: " + key);
        }
        let mapping = new UrlToActivityMapping();
        mapping.key = key;
        mapping.activityClass = activityClass;
        mapping.exposedProps = exposedProps;
        this.urlToClass[key] = mapping;
    }

    async console(){
        await this.showActivity(require("@/components/console/ConsoleActivity"));
    }
    async sample(){
        await this.showActivity(require("@/activity/samples/SampleActivity"));
    }
    async sampleZ(){
        await this.showActivity(require("@/activity/samples/SampleActivityX"));
    }

    /**
     * @param {*|string} activityClass
     * @param {Object.<string, *>} props
     * @param traceLabel
     * @param replace
     * @return {Promise<Activity|Vue>}
     */
    async showActivity(activityClass, props=null, traceLabel=null, replace=false){
        // oczekiwanie na zamknięcie poprzedniego acitivity w sytuacji gdy ktoś czeka na wynik z activity i
        // otwiera nowe activity w odpowiedzi na poprzednie

        await new Promise(r => setTimeout(r));
        await new Promise(r => setTimeout(r));
        if(replace){
            return this.replaceActivity(activityClass, props, traceLabel);
        }
        activityClass = await this.decodeActivityClass(activityClass);
        return this.workspace.showActivity(activityClass, props, traceLabel);
    }

    async decodeActivityClass(activityClass){
        if(typeof activityClass === "string"){
            activityClass = this.nameToClass[activityClass];

            if(activityClass === undefined){
                Log.debug("Activity not registered by name " + activityClass);
            }
        }
        if(typeof activityClass === "function"){
            activityClass = activityClass();
            activityClass = await Promise.resolve(activityClass);
        }

        if(activityClass.hasOwnProperty("default")){
            activityClass = activityClass.default;
        }

        return activityClass;
    }

    /**
     *
     * @param activity
     * @param props
     * @param traceLabel
     * @returns {Promise<boolean|*>}
     */
    async replaceActivity(activity, props, traceLabel=null){
        props = props || {};
        return this.replaceActivities([{activityClass:await this.decodeActivityClass(activity), props, traceLabel}]);
    }

    /**
     * @param { {activityClass:*, props:Object, traceLabel:string|null }[] } activitiesDefinition
     */
    replaceActivities(activitiesDefinition){
        let runList = [];

        for(let i=0; i<activitiesDefinition.length; i++){
            if(typeof activitiesDefinition[i].activityClass === "string"){
                let activityClass = this.nameToClass[activitiesDefinition[i].activityClass];
                if(activityClass === undefined){
                    Log.debug("Activity not registered by name " + activityClass);
                    return false;
                }
                runList.push({activityClass, 'props': activitiesDefinition[i].props, traceLabel: activitiesDefinition[i].traceLabel});
            }else {
                runList.push(activitiesDefinition[i]);

            }

        }
        return this.workspace.replaceActivities(runList);
    }

    /**
     * @return {Activity}
     */
    getTopActivity(){
        return this.workspace.getTopActivity()
    }

    holdResizeObservers(){
        this.workspace.holdResizeObservers()
    }

    reactivateResizeObservers(){
        this.workspace.reactivateResizeObservers()
    }

    /**
     * @return {Activity}
     */
    getBackActivity(){
        return this.workspace.getBackActivity();
    }

    /**
     * @param id
     * @return {Activity|null}
     */
    findActivityById(id){
        return id ? this.workspace.findActivityById(id) : null;
    }

    /**
     * @param el
     * @return {null|Activity}
     */
    findActivity(el){
        return this.findActivityById(Activity.findActivityId(el));
    }

    /**
     * @param {function(Activity)} callback
     * @return {[]}
     */
    forEachActivity(callback){
        return this.workspace._forEachActivity(callback);
    }
    /**
     * @return {Promise<boolean>} - true if activity was closed; false if it close operation was interupted by Activity
     */
    closeTopActivity(){
        return this.workspace.closeTopActivity();
    }

    closeTopActivityForReopen(){
        return this.workspace.closeTopActivityForReopen();
    }

    closeAll(force=false){
        return this.workspace.closeAll(force);
    }

    disableFade(){
        return this.workspace.disableFade();
    }

    enableFade(){
        return this.workspace.enableFade();
    }

    /**
     * Internal function to connect Manager and workspace
     * @param {ActivityWorkspace} workspace 
     */
    _bindActivityWorkspace(workspace){
        this.workspace = workspace;
    }

    /**
     * @param {*} activityClass 
     * @param {Object} props 
     */
    addToAutostart(activityClass, props){
        let existing = this.autostart.find(a => a.activityClass == activityClass)
        if(existing){
            existing.props = props;
            return;
        }
        // console.log("Autostart added");
        this.autostart.push({activityClass, props});
    }

    runAutostart(){
        // console.log("Autostart size:" + this.autostart.length);
        this.autostart.forEach( e => this.showActivity(e.activityClass, e.props));
        this.autostart = [];
    }

    bootstrapWorkspaceFromPath(bootstrapUrl){
        let decoded = ActivityUrlDecoder.decode(bootstrapUrl, this.urlToClass);
                
        if(!decoded.errors){
            let autostartList = [];
            decoded.activities.forEach(element => {
                autostartList.push({activityClass:element.activityClass, props:element.validatedProps });
            });

            // console.log("Autostart size:" + this.autostart.length);
            this.autostart.forEach( e => autostartList.push(e));
            this.autostart = [];
            this.replaceActivities(autostartList);
        }
    }

    _reset(){
        this.workspace=null;
        this.urlToClass={};
        this.nameToClass = {}        
    }

    /**
     * @param {string} s 
     * @return {string}
     */
    camelToDash(s){
        let dashed = s.replace(/([A-Z])/g, "-$1");
        const toDash = /[^a-z0-9]/gi;
        const toSingleDash = /-+/gi;
        return dashed.toLowerCase().trim().replace(toDash, "-").replace(toSingleDash, '-').replace(/^-/, '').replace(/-$/, '');
    }
    showTest(){
        const SimpleActivity = () => require("@/activity/templates/SimpleActivityTemplate");
        ActivityManager.showActivity(SimpleActivity);
    }
}

const ActivityManager = new _ActivityManager();
_ActivityManager.instance = ActivityManager;
window['ActivityManager'] = _ActivityManager.instance ;

export default ActivityManager;